import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createInquiry = (data) =>
  axios.post(`${API}/inquiries`, data).then((r) => r.data);

export const createOrder = (data) =>
  axios.post(`${API}/orders`, data).then((r) => r.data);
